export const BASE_URL = "https://www.beritaharian.sg";

export const CACHE_EXPIRY_TIME = 300;
export const CACHE_MOBILE_SECTION_LISTING_EXPIRY_TIME = 3;
export const CACHE_EXPIRY_TIME_TWO_DAYS = 2 * 24 * 60 * 60;
export const CACHE_KEY_TOP_ARTICLES = "push-notifications";
export const MAX_CACHE_SIZE_TOP_ARTICLES = 100;

export const TAG_SPECIAL_REPORT = "laporan-khas";

export const CLIENT_ID_HEADER = "bh-web";

export const AWS_MOBILE_BACKEND_REGION = "ap-southeast-1";
export const AWS_MOBILE_BANCKEND_SERVICE = "execute-api";
